// @flow strict

import * as React from 'react';
import type { CurrencyType } from './currencies';
import { CURRENCY, CURRENCY_SYMBOLS } from './currencies';
import styles from './styles.scss';

type Props = {|
  currency: CurrencyType,
  onSelect: (currency: CurrencyType) => void,
  symbolVisible?: boolean,
|};

const Currency = ({ currency, onSelect, symbolVisible = true }: Props) => (
  <div className={styles.currencyContainer}>
    <select
      className={styles.currencySelector}
      value={currency}
      data-testid="currency"
      onChange={event => {
        onSelect(event.target.value);
      }}
      autoComplete="off"
    >
      {Object.keys(CURRENCY).map(c => (
        <option value={c} key={c}>
          {symbolVisible ? CURRENCY_SYMBOLS[c] : ''} {CURRENCY[c]}
        </option>
      ))}
    </select>
  </div>
);

export default Currency;
